import { forwardRef, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react'
import classes from './Game.module.scss'
import TestContainer from './components/TestContainer';
import { useSelector } from 'react-redux';
const Game = forwardRef(function Game({ onAnswer }, gameRef) {

  useImperativeHandle(gameRef, () => ({
    animateEntry: async () => {
      // console.log("animación de entrada")
    },
    animateFail: async () => {
      // console.log("animación de fallo")
    }
  }));

  const [showTest, setShowTest] = useState(false);
  const isFullScreen =  useSelector(state => state.settings.isFullscreen);

  const gameContainer = useRef();

  useLayoutEffect(() => {
    
    const resizeObserver = new ResizeObserver((entries) => {
      setShowTest(false);

      const refreshGame = setTimeout(() => {
        setShowTest(true);
        const contentHeight = entries[0].target.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--interface-space', contentHeight + 'px');
        clearTimeout(refreshGame);
      }, 0);

    });

    if (gameContainer.current) {
      resizeObserver.observe(gameContainer.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [isFullScreen]);

  return (
    <div className={classes.game} ref={gameContainer}>
      {showTest && (
        <div className={classes.gameHeight}>
          <TestContainer onAnswer={onAnswer} />
        </div>
      )}
    </div>
  )
})

export default Game